import { render, staticRenderFns } from "./cascader-items.vue?vue&type=template&id=089c0642&"
import script from "./cascader-items.vue?vue&type=script&lang=js&"
export * from "./cascader-items.vue?vue&type=script&lang=js&"
import style0 from "./cascader-items.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports